var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgO = function SvgO(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.4,
    height: 54.5,
    viewBox: "0 0 44.4 54.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 11.6c2.1 2.8 4.1 5.2 5.9 7.5 6.4 8 9.5 12.1 9.5 16.4 0 6.5-7.1 11.9-15.4 11.9S6.8 41.9 6.8 35.5c0-4.3 3.1-8.4 9.5-16.4 1.8-2.2 3.8-4.7 5.9-7.5m0-11.6C9.9 17.9 0 25.2 0 35.6s10 18.8 22.2 18.8S44.4 46 44.4 35.6c0-10.5-9.9-17.7-22.2-35.6",
    fill: "#fff"
  })));
};

export default SvgO;